import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { siteData } from '@/mocks/siteData';
import ArticleCard from '@/components/feature/ArticleCard';
import CategoryTabs from '@/components/feature/CategoryTabs';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured);
  const recentArticles = articles.slice(0, 6);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://example.com/",
            "name": "黄油游戏官方指南·玩转黄油游戏全攻略",
            "description": "黄油游戏是深受玩家喜爱的创意互动娱乐品类，汇聚黄油游戏完整玩法介绍、热门作品推荐、新手入门技巧与进阶攻略。",
            "isPartOf": {
              "@type": "WebSite",
              "name": "黄油游戏官方指南",
              "url": "https://example.com/"
            }
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": siteData.faq.map((item) => ({
              "@type": "Question",
              "name": item.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer,
              },
            })),
          }),
        }}
      />

      <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20abstract%20gaming%20world%20with%20flowing%20golden%20light%20particles%2C%20soft%20geometric%20patterns%20floating%20in%20warm%20amber%20and%20cream%20atmosphere%2C%20dreamy%20ethereal%20game%20portal%20effect%2C%20gentle%20gradients%20from%20warm%20orange%20to%20soft%20cream%2C%20abstract%20artistic%20composition%2C%20minimalist%20and%20elegant%2C%20no%20text%20no%20realistic%20objects&width=1600&height=900&seq=hero-home-2026&orientation=landscape"
          alt="黄油游戏官方指南"
          className="absolute inset-0 w-full h-full object-cover"
          width="1600"
          height="900"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 md:mb-5 leading-tight text-balance">
            玩转黄油游戏，从这里开始
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
            黄油游戏官方指南 - 汇聚黄油游戏完整玩法介绍、热门作品推荐、新手入门技巧与进阶攻略，帮助每位玩家发现属于自己的沉浸式黄油游戏体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/beginner-guide"
              className="px-6 py-2.5 md:px-8 md:py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              新手入门指南
            </Link>
            <Link
              to="/category/hot-recommendations"
              className="px-6 py-2.5 md:px-8 md:py-3 bg-background-50/20 text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              热门黄油游戏推荐
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
                精选黄油游戏攻略
              </h2>
              <p className="text-sm text-foreground-500 mt-1">不容错过的黄油游戏热门内容</p>
            </div>
            <CategoryTabs />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
            {featuredArticles.concat(recentArticles.filter(a => !a.featured)).slice(0, 6).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">黄油游戏内容分类</h2>
            <p className="text-sm text-foreground-500">五大板块，覆盖黄油游戏全领域</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-product-shop="">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-base font-heading text-foreground-950 mb-1.5 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">{cat.description}</p>
                <span className="text-xs text-primary-500 font-medium">{cat.articleCount} 篇攻略</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950">最新黄油游戏文章</h2>
              <p className="text-sm text-foreground-500 mt-1">持续更新的黄油游戏攻略内容</p>
            </div>
            <Link
              to="/category/hot-recommendations"
              className="flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
            {[...articles].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 6).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">黄油游戏常见问题</h2>
            <p className="text-sm text-foreground-500">黄油游戏新手最关心的问题解答</p>
          </div>
          <div className="space-y-3">
            {siteData.faq.map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-800 list-none">
                  <span>{faq.question}</span>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 text-foreground-400 group-open:rotate-180 transition-transform">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.answer}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">开启你的黄油游戏之旅</h2>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
            无论你是黄油游戏新手还是资深玩家，黄油游戏官方指南都为你准备了最全面的攻略与推荐。加入我们，一起探索黄油游戏的精彩世界。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/beginner-guide"
              className="px-6 py-2.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-6 py-2.5 bg-secondary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}